var links = document.links;
for (let i = 0, linksLength = links.length; i < linksLength; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = "_blank";
    links[i].rel = "noreferrer noopener";
  }
}
$(
  "[data-popup-video], [data-popup-video] .halo-popup-close, .background-overlay"
).on("click", function (e) {
  let modalContent = $("[data-popup-video] .halo-popup-content");
  if (!modalContent.is(e.target) && !modalContent.has(e.target).length) {
    $("body").removeClass("video-show");
    $("[data-popup-video] iframe").remove();
  }
});

